import request from './adminRequest'

export const mentorApplicationApi = {
  listMentorApplication (params) {
    return request.get('/mentorApplications/', { params: params })
  },
  getMentorApplication (uid) {
    return request.get('/mentorApplications/' + uid)
  },
  updateMentorApplication (uid, data) {
    return request.put('/mentorApplications/' + uid, data)
  },
  deleteMentorApplication (uid) {
    return request.delete('/mentorApplications/' + uid)
  },
  approveMentorApplication (uid) {
    return request.put('/mentorApplications/approve/' + uid)
  },
  rejectMentorApplication (uid) {
    return request.put('/mentorApplications/reject/' + uid)
  },
}
export default mentorApplicationApi
